import React, { useCallback } from 'react';
import { flex } from 'styles/utils';
import { Button } from 'components/deprecated/Button';
import { cx } from '@linaria/core';
import { cssHelpers } from 'styles/utils/core';
import { useModalActions } from 'components/ModalManager/Context';
import { DeleteAlert } from 'components/Alert';
import { TUserKeysMST, KeyCreationEventType } from 'modules/Apps/mstStores/UserKeysMST';
import { KEY_NAMES, AddApiKeyModal } from 'modules/Apps/components/apiKeyTable/AddApiKeyModal';
import { dialog, dialogOuterContentWrapper, dialogContentWrapper } from 'modules/Apps/components/apiKeyTable/styles';
import { UpdateApiKeyModal } from 'modules/Apps/components/apiKeyTable/UpdateApiKeyModal';
import { modalKeys, APIKeyType, PATKeyType } from 'modules/AppSettings/ApiKeysTable/constants';
export function useDeleteAPIKeyModal({
  store,
  userOrOrgId,
  message
}: {
  store: TUserKeysMST;
  userOrOrgId: string;
  message: string;
}): (apiKeyId: string) => void {
  const {
    openModal,
    closeModal
  } = useModalActions();
  return useCallback((apiKeyId: string) => {
    openModal({
      id: modalKeys.apiKey.delete,
      title: 'Remove Api Key?',
      content: <>
            <p>{message}</p>
            <DeleteAlert />
          </>,
      makeActions: () => <div className={cx(flex.init, flex.justifyContent.end)}>
            <Button kind="outline" onClick={() => closeModal({
          id: modalKeys.apiKey.delete
        })} className={cssHelpers.margin.x[1]}>
              Cancel
            </Button>
            <Button kind="error" onClick={() => {
          store.deleteKey({
            userId: userOrOrgId,
            id: apiKeyId
          });
          closeModal({
            id: modalKeys.apiKey.delete
          });
        }}>
              Delete
            </Button>
          </div>
    });
  }, [store, userOrOrgId]);
}
export function useEditApiKeyModal(store: TUserKeysMST, params: {
  type: typeof APIKeyType | typeof PATKeyType;
  userId: string;
  appId?: string;
}): (apiKeyId: string, apiKey: CF.API.ApiKeys.KeyData) => void {
  const {
    openModal
  } = useModalActions();
  const modalKey = params.type === APIKeyType ? modalKeys.apiKey.edit : modalKeys.patKey.edit;
  const {
    closeModal
  } = useModalActions();
  const onClose = (): void => {
    closeModal({
      id: modalKey
    });
  };
  return useCallback((apiKeyId: string, apiKey: CF.API.ApiKeys.KeyData) => {
    openModal({
      id: modalKey,
      title: `Edit ${KEY_NAMES[params.type]}`,
      content: <UpdateApiKeyModal store={store} apiKeyId={apiKeyId} apiKey={apiKey} onClose={onClose} {...params} />,
      makeActions: () => null
    });
  }, [openModal, store]);
}
export function useAddApiKeyModal(store: TUserKeysMST, params: {
  type: typeof APIKeyType;
  userId: string;
  appId: string;
} | {
  type: typeof PATKeyType;
  userId: string;
}, callback?: (eventType: KeyCreationEventType) => void): () => void {
  const {
    openModal
  } = useModalActions();
  const modalKey = 'appId' in params ? modalKeys.apiKey.add : modalKeys.patKey.add;
  const {
    closeModal
  } = useModalActions();
  const onClose = (): void => {
    closeModal({
      id: modalKey
    });
  };
  return useCallback((): void => {
    openModal({
      id: modalKey,
      title: `Create ${KEY_NAMES[params.type]}`,
      content: <AddApiKeyModal store={store} onClose={onClose} callback={callback} {...params} />,
      makeActions: () => null,
      className: dialog,
      contentOuterWrapperClassName: dialogOuterContentWrapper,
      contentWrapperClassName: dialogContentWrapper
    });
  }, [openModal, store, callback]);
}